import React, { useEffect, useRef, useState } from "react";
import "./MyCampaignsPage.css";
import {
  Col,
  Row,
  Input,
  Button,
  Typography,
  Table,
  Card,
  Segmented,
  Divider,
  Popover,
  Space,
  Drawer,
  Spin,
  message,
  Menu,
  Form,
  Tooltip,
  Modal,
} from "../../../components/common/utils/antd-imports/AntdImports";
import "../../../../src/main.css";
import NewCampaignModal from "../../../components/modal/NewCampaignModal";
import CartIcon from "./../../../components/common/reusable-svg-icons/cart-icon";
import { ReactComponent as RenameIcon } from "../../../assests/rename-icon.svg";
import { ReactComponent as AddProductIcon } from "../../../assests/addproduct.svg";
import { ReactComponent as ShareIcon } from "../../../assests/share.svg";
import { ReactComponent as DuplicateIcon } from "../../../assests/duplicate.svg";
import { ReactComponent as DeleteIcon } from "../../../assests/delete.svg";
import { ReactComponent as Warning } from "../../../assests/emojione_warning.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { CopyOutlined, EllipsisOutlined } from "@ant-design/icons";
import { ReactComponent as SearchIcon } from "../../../assests/search-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  buyerDashboardCampaignsCount,
  cartDetails,
  getBuyerCampaigns,
  renameCampaignName,
  saveCampaignToCart,
  searchBuyerCampaigns,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import ShareCampaign from "../../../components/modal/share-campaign-modal/ShareCampaign";
import FloatingInput from "../../../components/common/float-input/FloatInput";
import DuplicateCampaign from "../../../components/modal/duplicate-campaign/DuplicateCampaign";
import DeleteCamapign from "../../../components/modal/delete-campaign/DeleteCampaign";
import EditCampaign from "../../../components/modal/edit-campaign/EditCampaign";
import {
  formatToUSCurrency,
  handleCopy,
} from "../../../components/common/utils/Utils";
import EmptyRecordsCard from "../../../components/common/empty-view-card/EmptyViewCard";
import {
  addBreadcrumb,
  setBreadcrumbs,
} from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb";

const MyCampaignsPage = ({ isDashboard }) => {
  const { Text } = Typography;
  const addCart = "Add to cart";
  const offerRequestedTooltip =
    "This action cannot be performed if the offer is in requested state";
  const noProductsTooltip =
    "This action cannot be performed when there are no products in the campaign.Please add a product to proceed.";
  const customTermsTooltip =
    "This action cannot be performed as custom terms are requested";
  const inCartTooltip = "Item already in cart";
  const dispatch = useDispatch();
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Get `segment` from the URL, default to "saved_campaign" if not found
  const [alignValue, setAlignValue] = useState(
    searchParams.get("segment") || "saved_campaign",
  );
  const [hoveredValue, setHoveredValue] = useState("");
  const [newCampaignModal, setNewCampaignModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Store current page
  const [editCampaignEntire, setEditCampaignEntire] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState([]); // Store selected campaign
  const [campaignDetails, setCampaignDetails] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [menu, setMenu] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [inCart, setInCart] = useState(false);
  const [campaignPurchased, setCampaignPurchased] = useState(false);
  const [openPopoverKey, setOpenPopoverKey] = useState(null);
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [deleteCampaignId, setDeleteCampaignId] = useState();
  const [shareCampaignId, setShareCampaignId] = useState(null);
  const [deleteCampaignModal, setDeleteCampaignModal] = useState(false);
  const [shareCampaign, setShareCampaign] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [loggedInUser, setloggedInUser] = useState({
    clientId: null,
    user_id: null,
    email: null,
    firstName: null,
    lastName: null,
    user_type: null,
    user_role: null,
  });

  const [user, setUser] = useState();
  const isSavedCampaigns = false;
  const campaignsCount = useRef(0);
  const containerRef = useRef(null);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { Meta } = Card;

  const {
    buyerCampaignsList,
    getBuyerCampaignsLoading,
    filteredCampaignsList,
    deleteCampaignResponse,
    duplicateCampaignResponse,
    editCampaignResponse,
    shareCampaignResponse,
    isRenamingLoading,
    isSearchCampaignLoading,
  } = useSelector((state) => state.buyerCampaigns);
  const { dashboardCampaigns } = useSelector((state) => state?.buyerDashboard);
  const { campaignCartDetails } = useSelector((state) => state?.campaignscart);
  const [campaignName, setCampaignName] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [renameDraw, setRenameDraw] = useState(false);
  const [duplicateCampaign, setDuplicateCampaign] = useState(false);
  const [editCampaign, setEditCampaign] = useState(false);
  const [showAddtoCart, setShowAddtoCart] = useState(false);
  const searchDidMountRef = useRef(false);
  const { isLoading: campaignsCartLoader, isSaveCartLoading } = useSelector(
    (state) => state.campaignscart,
  );
  const isLoading =
    getBuyerCampaignsLoading ||
    campaignsCartLoader ||
    isRenamingLoading ||
    isSaveCartLoading ||
    isSearchCampaignLoading;
  useEffect(() => {
    if (!searchDidMountRef.current) {
      searchDidMountRef.current = true;
      return;
    } else {
      if (!searchValue) {
        dispatch(getBuyerCampaigns({ value: alignValue, currentPage }));
      }
      const delayDebounce = setTimeout(() => {
        if (searchValue) {
          dispatch(
            searchBuyerCampaigns({
              value: alignValue,
              searchdata: searchValue,
            }),
          );
        }
      }, 400);

      return () => {
        clearTimeout(delayDebounce);
      };
    }
  }, [searchValue]);

  const goToSubPage = (record) => {
    if (alignValue === "saved_campaign") {
      dispatch(
        setBreadcrumbs([
          {
            title: "Dashboard",
            path: `/buyer/dashboard`,
          },
          {
            title: "Campaigns",
            path: `/buyer/mycampaigns?segment=${alignValue}`,
          },
          {
            title: "Saved Campaigns",
            path: `/buyer/mycampaigns?segment=${alignValue}`,
          },
          {
            title: record?.campaign_name,
            path: `/buyer/campaigndetails?_id=${btoa(record?.campaign_id)}`,
          },
        ]),
      );
    }
    dispatch(
      addBreadcrumb({
        title: record?.campaign_name,
        path: `/buyer/campaigndetails?_id=${btoa(record?.campaign_id)}`,
      }),
    );
  };

  const goToSubPage1 = ({ title, path }) => {
    dispatch(
      addBreadcrumb({
        title,
        path,
      }),
    );
  };

  const onChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleOpenMenu = (campaign) => {
    setCampaignDetails(campaign);
    setSelectedCampaign([campaign?.id]); // Store the clicked campaign
    setMenu(true);
    setDisableButton(campaign?.offerDetails_status == 1 ? true : false);
    setInCart(campaign?.checkout_checked == 1 ? true : false);
    setCampaignPurchased(campaign?.status > 100 ? true : false);
    setOpenPopoverKey(null);
  };

  const handleDelete = (record) => {
    setDeleteCampaignId(record?.campaign_id || record?.id);
    setDeleteCampaignModal(true);
    setMenu(false);
  };

  const handleShareCampaign = (record) => {
    setShareCampaignId(record?.campaign_id || record?.id);
    setShareCampaign(true);
  };

  const handleDuplicateCampaign = (record) => {
    setCampaignName(record?.campaign_name);
    setShareCampaignId(record?.campaign_id || record?.id);
    setDuplicateCampaign(true);
  };

  const handleRenameCampaign = (record) => {
    setEditCampaignEntire(record);
    setEditCampaign(true);
  };

  const handleMenuWithCustomTerms = () => {
    if (campaignDetails?.all_custom_terms_applied == 1) {
      setMenu(false);
    }
  };
  const handleEdit = (record) => {
    setEditValue(record.name);
    setRenameDraw(true);
  };
  const handleSave = () => {
    const payload = {
      campaign_id:
        selectedCampaign?.campaign_id ||
        selectedCampaign?.id ||
        selectedCampaign[0],
      name: editValue,
    };
    dispatch(renameCampaignName(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        setRenameDraw(false);
        setEditingKey(""); // Reset editing mode
      }
    }); // Dispatch here when Enter is pressed
  };
  //handle add to cart

  const handleAddtoCart = (item, useSelectedCampaigns = false) => {
    const campaignIds = useSelectedCampaigns
      ? selectedCampaign
      : [item?.id ?? item?.campaign_id];
    const validCampaignIds = campaignIds.filter(
      (id) => id !== undefined && id !== null && id !== "" && id !== "N/A",
    );
    if (validCampaignIds.length === 0) {
      message.warning("Campaign ID is not available. Please try again.");
      console.error("Missing campaign ID:", item);
      return;
    }

    if (
      !useSelectedCampaigns &&
      (item?.sold_out_status?.sold_status === 1 || item?.sold_out_status === 1)
    ) {
      message.warning(
        "Some products are already sold and cannot be added to the cart.",
      );
      return;
    }
    const payload = {
      campaign_id: validCampaignIds,
      loggedInUser,
    };
    dispatch(saveCampaignToCart(payload)).then(() => {
      dispatch(cartDetails());
      dispatch(getBuyerCampaigns({ value: alignValue, currentPage })).then(
        () => {
          setShowAddtoCart(false);
        },
      );
    });

    setSelectedRowKeys([]);
    setSelectedCampaign([]);
  };

  const handleRowClick = (record) => ({
    onClick: (event) => {
      // Find the clicked cell (td)
      const cell = event.target.closest("td");
      if (!cell) return;

      // Find index of cell inside the row
      const cellIndex = Array.from(cell.parentNode.children).indexOf(cell);
      if (cellIndex === -1) return;
      // Get the column key based on the index
      const columnKey =
        cellIndex > 0 ? columns[cellIndex - 1]?.key : "campaignId";
      if (columnKey && columnKey !== "action") {
        goToSubPage(record);
        navigate(`/buyer/campaigndetails?_id=${btoa(record?.campaign_id)}`);
      }
    },
  });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // table three dots menu
  const content = (record) => (
    <div className="campaign-action-items">
      <Menu>
        <Menu.Item
          key={"rename"}
          onClick={() => {
            handleRenameCampaign(record);
            setOpenPopoverKey(null);
          }}
        >
          <span className="action-items-text common-text-101828-14-500">
            <RenameIcon className="action-icons" />
            Rename
          </span>
        </Menu.Item>
        <Menu.Item onClick={() => handleShareCampaign(record)} key={"share"}>
          <span className="action-items-text common-text-101828-14-500">
            <ShareIcon className="action-icons" />
            Share
          </span>
        </Menu.Item>
        <Menu.Item
          key={"addProduct"}
          disabled={disableButton || campaignPurchased}
          className={`cart-btn-container ${
            alignValue !== "saved_campaign" || record?.offerDetails_status == 1
              ? "not-clickable"
              : ""
          }`}
          onClick={() => {
            if (alignValue === "saved_campaign") {
              handleAddProduct(record);
            }
          }}
        >
          <>
            {disableButton ||
            campaignPurchased ||
            record?.checkout_checked == 1 ? (
              <Tooltip title={getAddProductTooltip()}>
                {addProductButton}
              </Tooltip>
            ) : (
              <> {addProductButton}</>
            )}
          </>
        </Menu.Item>
        <Menu.Item
          key={"duplicate"}
          className={`cart-btn-container saved_campaign`}
          onClick={() => handleDuplicateCampaign(record)}
        >
          <span className="action-items-text common-text-101828-14-500">
            <DuplicateIcon className="action-icons" />
            Duplicate Campaign
          </span>
        </Menu.Item>
        <Menu.Item
          key={"delete"}
          disabled={disableButton || inCart || campaignPurchased}
          className={` ${
            disableButton || inCart || campaignPurchased ? "disable-button" : ""
          }`}
          onClick={() => {
            if (!(campaignPurchased || disableButton || inCart))
              handleDelete(record);
          }}
        >
          {disableButton || inCart || campaignPurchased ? (
            <Tooltip title={getTooltip}>{deleteCampaignButton}</Tooltip>
          ) : (
            <> {deleteCampaignButton}</>
          )}
        </Menu.Item>
      </Menu>
    </div>
  );
  const getAddProductTooltip = () => {
    const tooltip = getTooltip();
    return tooltip === customTermsTooltip ? "" : tooltip;
  };
  const getTooltip = () => {
    if (inCart || (inCart && disableButton)) return customTermsTooltip;
    if (disableButton) return offerRequestedTooltip;
    if (campaignPurchased)
      return "This action cannot be performed, when it is already purchased";
  };
  const getAddToCartTooltip = (record) => {
    if (record?.added_to_cart == 1) return inCartTooltip;
    if (record?.all_custom_terms_applied) return customTermsTooltip;
    if (record?.offerDetails_status == 1) return offerRequestedTooltip;
    if (!record?.products) return noProductsTooltip;
    if (record?.sold_out_status == 1) return "Products are sold out";
  };
  const addProductButton = (
    <span className="action-items-text common-text-101828-14-500">
      <AddProductIcon className="action-icons" />
      Add Product
    </span>
  );
  const deleteCampaignButton = (
    <span className="action-items-text common-text-101828-14-500">
      <DeleteIcon className="action-icons " />
      Delete Campaign
    </span>
  );
  // table columns
  const columns = [
    {
      title: "Campaign ID",
      dataIndex: "campaign_cid",
      render: (text, record) => (
        <>
          <div className="product-copy-text-field">
            <Button
              type="link"
              className="campaign-id-button"
              onClick={() =>
                navigate(
                  `/buyer/campaigndetails?_id=${btoa(record?.campaign_id)}`,
                )
              }
            >
              {text}
            </Button>
            <CopyOutlined
              onClick={(e) => {
                e.stopPropagation(); // prevent tooltip close
                handleCopy(text);
              }}
              className="copy-icon"
            />
          </div>
        </>
      ),
      width: 240,
      key: "campaignId",
      sorter: (a, b) => parseInt(a.campaign_id) - parseInt(b.campaign_id),
    },
    {
      title: "Campaign Name",
      dataIndex: "campaign_name",
      width: 200,
      key: "campaignName",
      sorter: (a, b) => a.campaign_name.localeCompare(b.campaign_name),
      render: (text, record) =>
        editingKey === record.key ? (
          <Input
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onPressEnter={() => handleSave(record.key)}
          />
        ) : (
          <div className="product-copy-text-field">
            <Tooltip title={text}>
              <span className="campaign-name truncate common-text-101828-14">
                {" "}
                {text}
              </span>
            </Tooltip>
            <CopyOutlined
              onClick={(e) => {
                e.stopPropagation(); // prevent tooltip close
                handleCopy(text);
              }}
              className="copy-icon"
            />
          </div>
        ),
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      width: 137,
      key: "startDate",
      sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      width: 145,
      key: "endDate",
      sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
    },
    {
      title: "Price",
      dataIndex: "price",
      width: 130,
      key: "price",
      align: "right",
      sorter: (a, b) =>
        parseFloat(a.price.replace("$", "")) -
        parseFloat(b.price.replace("$", "")),
    },

    {
      title: "No. of Products",
      dataIndex: "products",
      width: 160,
      key: "products",
      sorter: (a, b) => parseInt(a.products) - parseInt(b.products),
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="col-for-maintain-center-warning-count">
            <span
              className="text-center-vertically"
              style={{ alignItems: "center" }}
            >
              {text}
            </span>
          </div>
          {record?.sold_out_status === 1 && (
            <span>
              <Tooltip
                title={
                  <span className="custom-tooltip-inner">
                    Some products are already sold and cannot be proceed....
                  </span>
                }
                color="#fff"
              >
                <Warning className="campaign-purchase-sold-icon" />
              </Tooltip>
            </span>
          )}
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>Actions</div>,
      dataIndex: "action",
      width: 185,
      key: "action",
      align: "center", // Centering UI elements too
    },
  ];

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container) return;

    if (
      container.scrollHeight - container.scrollTop <=
      container.clientHeight + 5
    ) {
      // User has scrolled to the bottom, increase page
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  // mapping a table campaigns data into a table function
  const mapApiResponseToTable = (apiResponse) => {
    if (!Array.isArray(apiResponse)) {
      return [];
    }

    return apiResponse?.map((item, index) => {
      campaignsCount.current = item?.user_campaigns_total_count;

      let record = {
        key: index + 1,
        campaign_id: item?.id || "N/A",
        campaign_cid: item?.cid || "N/A",
        campaign_name: item?.name || "N/A",
        start_date: item?.start_date ? formatDate(item?.start_date) : "N/A",
        end_date: item?.end_date ? formatDate(item?.end_date) : "N/A",
        price: item?.act_budget
          ? `${formatToUSCurrency(item.act_budget.toFixed(2))}`
          : `${formatToUSCurrency(0)}`,
        products: item?.product_count || 0,
        sold_out_status: item?.sold_out_status?.sold_status,
        status: item?.status,
        offerDetails_status: item?.offerDetails_status,
        checkout_checked: item?.checkout_checked,
        all_custom_terms_applied: item?.all_custom_terms_applied,
        action: (
          <Space direction="horizontal">
            <div
              className={`cart-btn-container ${
                alignValue !== "saved_campaign" ? "not-clickable" : ""
              }`}
              onClick={() => {
                if (alignValue === "saved_campaign") {
                  handleAddtoCart(item);
                }
              }}
            >
              <CartIcon
                color="#d2042d"
                className="action-icons action-item default-color"
              />
              {item?.added_to_cart == 1 ? (
                <span className="">Added to Cart</span>
              ) : (
                <span className="action-item default-color">{addCart}</span>
              )}
            </div>
            <div className="campaign-action-items">
              <Popover
                content={() => content(record)}
                trigger="click"
                placement="bottomLeft"
              >
                <Button
                  className="ellipsis-btn"
                  onClick={() => handleOpenMenu(record)}
                >
                  <EllipsisOutlined className="rotate-ellipsis rotate-ellipsis-css rotate-ellipsis-icon" />
                </Button>
              </Popover>
            </div>
          </Space>
        ),
      };

      record.action = (
        <Space direction="horizontal">
          {[100, 1300].includes(item?.status) && (
            <div
              className={`cart-btn-container ${
                alignValue !== "saved_campaign" ? "not-clickable" : ""
              }`}
              onClick={() => {
                if (
                  alignValue === "saved_campaign" &&
                  item?.product_count > 0 &&
                  item?.sold_out_status?.sold_status != 1 &&
                  item?.added_to_cart != 1
                ) {
                  handleAddtoCart(item);
                }
              }}
            >
              {item?.added_to_cart != 1 && (
                <CartIcon
                  isDisabled={
                    item?.added_to_cart == 1 ||
                    item?.product_count == 0 ||
                    item?.all_custom_terms_applied == 1 ||
                    item?.sold_out_status == 1
                  }
                  color={
                    item?.added_to_cart == 1 ||
                    item?.product_count == 0 ||
                    item?.all_custom_terms_applied == 1 ||
                    item?.sold_out_status == 1
                      ? "#808080"
                      : "#d2042d"
                  }
                  className={`action-icons action-item default-color ${
                    inCart ||
                    item?.added_to_cart == 1 ||
                    disableButton ||
                    item?.all_custom_terms_applied != 1 ||
                    item?.product_count == 0 ||
                    item?.sold_out_status == 1
                      ? "disabled-button"
                      : ""
                  }`}
                />
              )}
              {item?.added_to_cart == 1 ||
              item?.sold_out_status == 1 ||
              item?.all_custom_terms_applied == 1 ||
              item?.product_count == 0 ? (
                <Tooltip title={() => getAddToCartTooltip(item)}>
                  {item?.added_to_cart == 1 ? (
                    <span className="action-item disable-button">
                      Added to Cart
                    </span>
                  ) : (
                    <span className="action-item disable-button">
                      {addCart}
                    </span>
                  )}
                </Tooltip>
              ) : (
                <>
                  <span className="action-item default-color">{addCart}</span>
                </>
              )}
            </div>
          )}
          <div className="campaign-action-items">
            <Popover
              content={() => content(record)}
              trigger="click"
              placement="bottomLeft"
            >
              <Button
                className="ellipsis-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenMenu(record);
                }}
              >
                <EllipsisOutlined className="rotate-ellipsis rotate-ellipsis-css rotate-ellipsis-icon" />
              </Button>
            </Popover>
          </div>
        </Space>
      );

      return record;
    });
  };
  const disabledCampaignIds = new Set(
    campaignCartDetails.map((item) => String(item?.campaign_id)),
  );
  // rowSelection object indicates the need for row selection
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setShowAddtoCart(selectedRows.length > 0);
      const campaignIdArray = [];
      selectedRows?.forEach((row) => {
        if (row?.campaign_id) {
          campaignIdArray.push(row?.campaign_id);
        }
      });
      setSelectedCampaign(campaignIdArray);
    },
    getCheckboxProps: (record) => {
      const recordCampaignId = String(record?.campaign_id);
      const isInCart = disabledCampaignIds?.has(recordCampaignId);
      const isSoldOut = record?.sold_out_status === 1;
      const noProducts = record?.products === "N/A";
      const isCustomTermsApplied = record?.all_custom_terms_applied == 1;
      const noProductsInCampaign = record?.products == 0;
      const offerApplied = record?.offerDetails_status == 1;
      const isDisabled =
        isInCart ||
        isSoldOut ||
        noProducts ||
        isCustomTermsApplied ||
        noProductsInCampaign ||
        offerApplied;
      return {
        disabled: isDisabled,
        // Column configuration not to be checked
        name: record?.name,
      };
    },
  };

  const handleAddProduct = (record) => {
    // Store campaignId and campaignInfo properly
    localStorage.setItem("campaignId", record?.campaign_id || record?.id);
    localStorage.setItem("CampaignName", record?.campaign_name || record?.name);
    localStorage.setItem("campaignFlag", 0);
    goToSubPage1({ title: "Shop", path: "/buyer/products" });

    navigate("/buyer/products", { state: { from: "/campaigns-page" } });
  };

  useEffect(() => {
    setAllCampaigns((prevCampaigns) => {
      let updatedCampaigns = [...prevCampaigns];
      if (isMobile) {
        if (filteredCampaignsList?.length >= 0 && searchValue) {
          updatedCampaigns = [];
          updatedCampaigns = [...updatedCampaigns, ...filteredCampaignsList];
        } else if (buyerCampaignsList?.length > 0) {
          const newBuyer = buyerCampaignsList.filter(
            (item) => !updatedCampaigns.some((c) => c.id === item.id),
          );
          updatedCampaigns = [...updatedCampaigns, ...newBuyer];
        }
      } else {
        // Desktop/tablet view: replace based on filtered or buyer campaigns
        if (filteredCampaignsList?.length >= 0) {
          updatedCampaigns = [...filteredCampaignsList];
        } else {
          updatedCampaigns = [...(buyerCampaignsList || [])];
        }
      }

      campaignsCount.current = updatedCampaigns.length;
      return updatedCampaigns;
    });
  }, [filteredCampaignsList, buyerCampaignsList]);

  useEffect(() => {
    // When switching segments, reset the campaigns to new buyerCampaignsList
    !isMobile &&
      setAllCampaigns(buyerCampaignsList || filteredCampaignsList || []);

    campaignsCount.current =
      filteredCampaignsList?.length || buyerCampaignsList?.length || 0;
    setloggedInUser({
      clientId: null,
      user_id: user?.user?.user_id,
      email: user?.user?.email,
      firstName: user?.user?.firstName,
      lastName: user?.user?.lastName,
      user_type: user?.user?.user_type,
      user_role: user?.user?.user_role,
    });
  }, [buyerCampaignsList, alignValue]); // Depend on buyerCampaignsList and segment changes

  useEffect(() => {
    setCurrentPage(1);
    setAllCampaigns([]);
    setSearchValue("");
  }, [alignValue]);
  useEffect(() => {
    // setAllCampaigns([]);
    dispatch(getBuyerCampaigns({ value: alignValue, currentPage }));
    dispatch(buyerDashboardCampaignsCount());
    const userInfo = localStorage.getItem("user");
    setUser(JSON.parse(userInfo));
  }, [
    alignValue,
    currentPage,
    deleteCampaignResponse,
    duplicateCampaignResponse,
    editCampaignResponse,
    shareCampaignResponse,
  ]);

  // Update the URL when `alignValue` changes
  useEffect(() => {
    if (isDashboard) return;
    navigate(`?segment=${alignValue}`, { replace: true });
  }, [alignValue, navigate]);
  useEffect(() => {
    const segment = searchParams.get("segment");
    if (segment === "saved_campaign") {
      dispatch(
        addBreadcrumb({
          title: "Saved Campaigns",
          path: "/buyer/mycampaigns?segment=saved_campaign",
        }),
      );
    } else {
    }
    if (segment && segment !== alignValue) {
      setAlignValue(segment);
    }
  }, [searchParams]);

  // Example Usage paasing the campaigns response
  const tableData = mapApiResponseToTable(allCampaigns);
  const handleTableChange = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current);
  };
  const getCampaignsTooltip = (hoveredValue) => {
    switch (hoveredValue) {
      case "saved_campaign":
        return "Campaigns before purchase";
      case "insertion_order":
        return "Campaign purchased. Waiting for Admin approval";
      case "scheduled":
        return "Admin approved campaigns";
      case "running":
        return "Running campaigns";
      case "closed":
        return "Closed campaigns";
      case "cancelled":
        return "Cancelled campaigns";
    }
  };
  return (
    <>
      {/* Hiding Search and campaign tabs if it is rendered in dashboard */}

      <div
        className={`${
          isDashboard && !isMobile
            ? "dashboard-saved-campaigns"
            : "my-campaigns-container"
        }`}
      >
        {!isDashboard && (
          <>
            <Row className="product-page-container">
              <Col xl={12} md={12} sm={24} className="campaigns-header">
                {!isMobile && (
                  <Row>
                    <BreadcrumbNav />
                  </Row>
                )}

                <Text className="advertisement-txt common-main-header-text">
                  My Campaigns
                </Text>
              </Col>
              <Col
                xl={12}
                lg={11}
                md={isMobile ? 24 : 10}
                className="search-products-sh search-input-mycampaigns"
              >
                <Input
                  prefix={<SearchIcon />}
                  className="search-input common-search"
                  placeholder="Search by campaign name..."
                  value={searchValue}
                  onChange={onChange}
                  allowClear
                  disabled={getBuyerCampaignsLoading}
                />
              </Col>
            </Row>
          </>
        )}
        {!isMobile && !isDashboard && <Divider />}
        <div className="campaigns-table-container">
          {!isDashboard && (
            <div className="campaign-utility">
              <Row className="segements-campaigns-actions-row">
                <Col span={!isMobile ? 20 : 24} className="segment-container">
                  <Segmented
                    className="campaign-segments"
                    value={alignValue}
                    onChange={(value) => {
                      setAlignValue(value);

                      const campaignBreadcrumbMap = {
                        saved_campaign: "Saved Campaigns",
                        insertion_order: "Insertion Order",
                        scheduled: "Scheduled Campaigns",
                        running: "Running Campaigns",
                        closed: "Closed Campaigns",
                        cancelled: "Cancelled Campaigns",
                      };

                      dispatch(
                        setBreadcrumbs([
                          { title: "Dashboard", path: "/buyer/dashboard" },
                          {
                            title: "Campaigns",
                            path: `/buyer/mycampaigns?segment=saved_campaign`,
                          },
                          {
                            title:
                              campaignBreadcrumbMap[value || "Saved Campaigns"],
                            path: `/buyer/mycampaigns?segment=${value}`,
                          },
                        ]),
                      );
                    }}
                    size="small"
                    options={[
                      {
                        value: "saved_campaign",
                        label: (
                          <div>
                            <Tooltip
                              style={{ fontFamily: "Roboto" }}
                              title={getCampaignsTooltip(hoveredValue)}
                              open={hoveredValue === "saved_campaign"}
                            >
                              <Row
                                justify="space-evenly"
                                align="middle"
                                onMouseEnter={() =>
                                  setHoveredValue("saved_campaign")
                                }
                                onMouseLeave={() => {
                                  setHoveredValue("");
                                }}
                              >
                                <span
                                  style={{
                                    fontFamily: "Roboto",
                                  }}
                                >
                                  Saved Campaigns
                                </span>
                                <span className="selectedCount">
                                  {dashboardCampaigns?.saved_campaigns || 0}
                                </span>
                              </Row>
                            </Tooltip>
                          </div>
                        ),
                      },
                      {
                        value: "insertion_order",
                        label: (
                          <div style={{ padding: 0 }}>
                            <Tooltip
                              title={getCampaignsTooltip(hoveredValue)}
                              open={hoveredValue === "insertion_order"}
                            >
                              <Row
                                justify="space-between"
                                align="middle"
                                onMouseEnter={() =>
                                  setHoveredValue("insertion_order")
                                }
                                onMouseLeave={() => {
                                  setHoveredValue("");
                                }}
                              >
                                <span style={{ fontFamily: "Roboto" }}>
                                  Insertion Order
                                </span>
                                <span className="selectedCount">
                                  {dashboardCampaigns?.insertion_order || 0}
                                </span>
                              </Row>
                            </Tooltip>
                          </div>
                        ),
                      },
                      {
                        value: "scheduled",
                        label: (
                          <div style={{ padding: 0 }}>
                            <Tooltip
                              title={getCampaignsTooltip(hoveredValue)}
                              open={hoveredValue === "scheduled"}
                            >
                              <Row
                                justify="space-between"
                                align="middle"
                                onMouseEnter={() =>
                                  setHoveredValue("scheduled")
                                }
                                onMouseLeave={() => {
                                  setHoveredValue("");
                                }}
                              >
                                <span style={{ fontFamily: "Roboto" }}>
                                  Scheduled
                                </span>
                                <span className="selectedCount">
                                  {dashboardCampaigns?.scheduled_campaigns || 0}
                                </span>
                              </Row>
                            </Tooltip>
                          </div>
                        ),
                      },
                      {
                        value: "running",
                        label: (
                          <div style={{ padding: 0 }}>
                            <Tooltip
                              title={getCampaignsTooltip(hoveredValue)}
                              open={hoveredValue === "running"}
                            >
                              <Row
                                justify="space-between"
                                align="middle"
                                onMouseEnter={() => setHoveredValue("running")}
                                onMouseLeave={() => {
                                  setHoveredValue("");
                                }}
                              >
                                <span style={{ fontFamily: "Roboto" }}>
                                  Running{" "}
                                </span>
                                <span className="selectedCount">
                                  {dashboardCampaigns?.active_campaigns || 0}
                                </span>
                              </Row>
                            </Tooltip>
                          </div>
                        ),
                      },
                      {
                        value: "closed",
                        label: (
                          <div style={{ padding: 0 }}>
                            <Tooltip
                              title={getCampaignsTooltip(hoveredValue)}
                              open={hoveredValue === "closed"}
                            >
                              <Row
                                justify="space-between"
                                align="middle"
                                onMouseEnter={() => setHoveredValue("closed")}
                                onMouseLeave={() => {
                                  setHoveredValue("");
                                }}
                              >
                                <span style={{ fontFamily: "Roboto" }}>
                                  Closed{" "}
                                </span>
                                <span className="selectedCount">
                                  {dashboardCampaigns?.completed_campaigns || 0}
                                </span>
                              </Row>
                            </Tooltip>
                          </div>
                        ),
                      },
                      {
                        value: "cancelled",
                        label: (
                          <div style={{ padding: 0 }}>
                            <Tooltip
                              title={getCampaignsTooltip(hoveredValue)}
                              open={hoveredValue === "cancelled"}
                            >
                              <Row
                                justify="space-between"
                                align="middle"
                                onMouseEnter={() =>
                                  setHoveredValue("cancelled")
                                }
                                onMouseLeave={() => {
                                  setHoveredValue("");
                                }}
                              >
                                <span style={{ fontFamily: "Roboto" }}>
                                  Cancelled{" "}
                                </span>
                                <span className="selectedCount">
                                  {allCampaigns[0]?.cancelled_campaigns_count ||
                                    0}
                                </span>
                              </Row>
                            </Tooltip>
                          </div>
                        ),
                      },
                    ]}
                  />
                </Col>
                <Col className="multiple-campaigns-cart-col">
                  {showAddtoCart &&
                    !isMobile &&
                    alignValue === "saved_campaign" && (
                      <Button
                        className="multiple-campaigns-cart-button"
                        type="primary"
                        onClick={() => handleAddtoCart()}
                      >
                        <Text className="multiple-campaigns-cart-button-text">
                          Add to cart
                        </Text>
                      </Button>
                    )}
                </Col>
              </Row>
            </div>
          )}
          {!isSavedCampaigns ? (
            <>
              {!isMobile || (!isMobile && isDashboard) ? (
                <>
                  {allCampaigns?.length > 0 ? (
                    <div className="all-campaigns table-content">
                      {isDashboard && (
                        <div className="campaigns-sub-header">
                          My Saved Campaigns
                        </div>
                      )}
                      <Table
                        onRow={handleRowClick}
                        className="campaigns-table campaign-utility"
                        rowSelection={
                          !isDashboard && alignValue === "saved_campaign"
                            ? {
                                type: "checkbox",
                                columnWidth: 50,
                                ...rowSelection,
                              }
                            : undefined
                        }
                        columns={columns}
                        scroll={{ x: "1300px" }} // Ensures horizontal scrolling
                        sticky
                        pagination={
                          filteredCampaignsList?.length > 0
                            ? false
                            : {
                                pageSizeOptions: [], // hide page size options
                                showSizeChanger: false,
                                total: campaignsCount?.current,
                                current: currentPage,
                                pageSize: 7,
                              }
                        }
                        dataSource={tableData}
                        onChange={handleTableChange}
                      />
                    </div>
                  ) : (
                    <>
                      <div className="campaign-card mobile-card">
                        <EmptyRecordsCard
                          header={"Campaigns"}
                          text={
                            "Create a campaign and add products to get started!"
                          }
                        />
                      </div>
                    </>
                  )}
                </>
              ) : (
                // Mobile screen for mycampaigns
                <>
                  {!isDashboard && (
                    <Input
                      allowClear
                      prefix={<SearchIcon />}
                      className="search-input campaign-search"
                      value={searchValue}
                      onChange={onChange}
                      placeholder="Search by campaigns name, or type..."
                    />
                  )}
                  {isDashboard && (
                    <div className="campaigns-sub-header">
                      My Saved Campaigns
                    </div>
                  )}
                  <>
                    {allCampaigns?.length > 0 ? (
                      <>
                        <div
                          ref={containerRef}
                          className="campaign-div"
                          onScroll={!searchValue ? handleScroll : undefined}
                        >
                          {allCampaigns &&
                            allCampaigns?.map((item, index) => (
                              <Card
                                className="mobile-campaign-card"
                                key={index?.id}
                              >
                                <div
                                  onClick={() =>
                                    navigate(
                                      `/buyer/campaigndetails?_id=${btoa(
                                        item?.id,
                                      )}`,
                                    )
                                  }
                                >
                                  <Row gutter={6}>
                                    <Col span={12} className="product-id">
                                      {item?.cid}
                                    </Col>
                                    <Col span={12} className="campaign-cost">
                                      {" "}
                                      {formatToUSCurrency(
                                        parseFloat(
                                          item?.act_budget || 0,
                                        ).toFixed(2),
                                      )}
                                    </Col>
                                  </Row>
                                  <Meta
                                    className="truncate"
                                    title={item?.name}
                                  />
                                  <Row gutter={6} className="detail-block">
                                    <Col span={15}>
                                      <div className="detail-label">
                                        Start From{" "}
                                      </div>
                                      <p className="product-availability">
                                        {formatDate(item?.start_date)}
                                        <div className="format-arrow">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="16"
                                            viewBox="0 0 23 16"
                                            fill="none"
                                          >
                                            <path
                                              d="M22.7071 8.7071C23.0976 8.31658 23.0976 7.68342 22.7071 7.29289L16.3431 0.928931C15.9526 0.538406 15.3195 0.538406 14.9289 0.928931C14.5384 1.31946 14.5384 1.95262 14.9289 2.34314L20.5858 8L14.9289 13.6569C14.5384 14.0474 14.5384 14.6805 14.9289 15.0711C15.3195 15.4616 15.9526 15.4616 16.3431 15.0711L22.7071 8.7071ZM8.74228e-08 9L22 9L22 7L-8.74228e-08 7L8.74228e-08 9Z"
                                              fill="#D2042D"
                                            />
                                          </svg>
                                        </div>
                                        {formatDate(item?.end_date)}
                                      </p>
                                    </Col>

                                    <Col
                                      span={9}
                                      sm={8}
                                      className="number-of-products-version-col"
                                    >
                                      <Row className="product-sold-status-row">
                                        {item?.sold_out_status?.sold_status ===
                                          1 && (
                                          <Tooltip
                                            title={
                                              <span className="custom-tooltip-inner">
                                                Some products are already sold
                                                and cannot be proceed....
                                              </span>
                                            }
                                            color="#fff"
                                          >
                                            <Warning className="campaign-purchase-sold-icon-version" />
                                          </Tooltip>
                                        )}
                                        <div>
                                          <div className="detail-label product-align ">
                                            {" "}
                                            No. of Products
                                          </div>
                                          <div className="quantity">
                                            {item?.product_count}
                                          </div>
                                        </div>
                                      </Row>
                                    </Col>
                                  </Row>
                                </div>
                                <Row
                                  justify={`${
                                    alignValue == "saved_campaign"
                                      ? "space-between"
                                      : "end"
                                  }`}
                                  align="middle"
                                  className="campaign-row"
                                >
                                  {alignValue == "saved_campaign" && (
                                    <Button
                                      className={`button add-cart-button ${
                                        item?.added_to_cart == 1 ||
                                        item?.product_count == 0 ||
                                        item?.offerDetails_status == 1
                                          ? "not-clickable"
                                          : ""
                                      }`}
                                      onClick={() => {
                                        if (item?.added_to_cart != 1) {
                                          handleAddtoCart(item);
                                        }
                                      }}
                                    >
                                      {item?.added_to_cart == 1 ? (
                                        <span> Added to Cart</span>
                                      ) : (
                                        <>
                                          <span className="alignment-button-class">
                                            <CartIcon color="#fff" /> Add to
                                            cart
                                          </span>
                                        </>
                                      )}
                                    </Button>
                                  )}
                                  <div className="ellipse-container">
                                    <Button
                                      className="ellipsis-mobile-btn"
                                      onClick={() => handleOpenMenu(item)}
                                    >
                                      <EllipsisOutlined className="rotate-ellipsis rotate-ellipsis-css" />
                                    </Button>
                                  </div>
                                </Row>
                              </Card>
                            ))}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="campaign-card mobile-card">
                          <EmptyRecordsCard
                            header={"Campaigns"}
                            text={
                              "Create a campaign and add products to get started"
                            }
                          />
                        </div>
                      </>
                    )}

                    {/* action items drawer */}

                    <Drawer
                      className="custom-bottom-drawer"
                      size="default"
                      placement="bottom"
                      closable={false} // Disable default close button
                      onClose={() => setMenu(false)}
                      open={menu}
                      onClick={(event) => {
                        if (campaignDetails?.all_custom_terms_applied) {
                          event.preventDefault();
                          return;
                        }
                        setMenu(false);
                      }}
                      drawerStyle={{
                        borderTopLeftRadius: "26px",
                        borderTopRightRadius: "26px",
                      }}
                    >
                      {selectedCampaign && (
                        <div className="campaign-drawer">
                          <Space direction="vertical" size={20}>
                            <Row>
                              <Text
                                className="campaign-drawer-actions"
                                onClick={() => {
                                  handleMenuWithCustomTerms();
                                  handleEdit(campaignDetails);
                                }}
                              >
                                Rename
                              </Text>
                            </Row>
                            <Row>
                              <Text
                                className="campaign-drawer-actions"
                                onClick={() => {
                                  handleMenuWithCustomTerms();
                                  handleShareCampaign(campaignDetails);
                                }}
                              >
                                Share
                              </Text>
                            </Row>
                            <Row
                              className={`cart-btn-container ${
                                selectedCampaign?.offerDetails_status == 1 ||
                                alignValue !== "saved_campaign"
                                  ? "not-clickable"
                                  : ""
                              }`}
                            >
                              <Text
                                className="campaign-drawer-actions"
                                onClick={(e) => {
                                  e.stopPropagation();

                                  if (alignValue === "saved_campaign") {
                                    handleAddProduct(campaignDetails);
                                    setMenu(false);
                                  }
                                }}
                              >
                                <Tooltip
                                  title={
                                    campaignDetails?.all_custom_terms_applied ==
                                    1
                                      ? getAddProductTooltip()
                                      : ""
                                  }
                                >
                                  Add Product
                                </Tooltip>
                              </Text>
                            </Row>
                            <Row
                              className={`cart-btn-container ${
                                alignValue !== "saved_campaign"
                                  ? "not-clickable"
                                  : ""
                              }`}
                            >
                              <Text
                                className="campaign-drawer-actions"
                                onClick={() => {
                                  if (alignValue === "saved_campaign") {
                                    handleMenuWithCustomTerms();
                                    handleDuplicateCampaign(campaignDetails);
                                  }
                                }}
                              >
                                Duplicate
                              </Text>
                            </Row>
                            <Row>
                              <Text
                                className={` ${
                                  campaignDetails?.all_custom_terms_applied == 1
                                    ? "disable-button"
                                    : "campaign-drawer-actions"
                                }`}
                                onClick={() => {
                                  if (
                                    campaignDetails?.all_custom_terms_applied !=
                                    1
                                  )
                                    handleDelete(campaignDetails);
                                }}
                              >
                                <Tooltip
                                  title={
                                    campaignDetails?.all_custom_terms_applied ==
                                    1
                                      ? getTooltip()
                                      : ""
                                  }
                                >
                                  Delete
                                </Tooltip>
                              </Text>
                            </Row>
                          </Space>
                        </div>
                      )}
                    </Drawer>

                    <Drawer
                      size="default"
                      placement="bottom"
                      closable={false}
                      onClose={() => setRenameDraw(false)}
                      open={renameDraw}
                    >
                      <div className="rename-draw-container">
                        <Row>
                          <Text className="rename-draw-header"> Rename</Text>
                        </Row>
                        <Form>
                          <Form.Item name="campaignname">
                            <Row
                              style={{
                                marginTop: 40,
                              }}
                            >
                              <FloatingInput
                                label={
                                  <>
                                    {`Enter new campaign name... `}
                                    {star}
                                  </>
                                }
                                customStyles={floatingInputStyles}
                                className="billboard-input-feild"
                                value={editValue}
                                onChange={(e) => setEditValue(e.target.value)}
                              />
                            </Row>
                          </Form.Item>

                          <Row className="campaign-action-buttons">
                            <Button
                              onClick={() => setRenameDraw(false)}
                              className="handle-rename-cancel-btn "
                            >
                              Cancel
                            </Button>
                            <Button
                              className="handle-rename-save-btn billboard-buttons billboard-button-2"
                              onClick={handleSave}
                              type="primary"
                            >
                              Save
                            </Button>
                          </Row>
                        </Form>
                      </div>
                    </Drawer>
                  </>
                </>
              )}
            </>
          ) : (
            <div>
              <div className="campaign-card mobile-card">
                <EmptyRecordsCard
                  header={"Campaigns"}
                  text={"Create a campaign and add products to get started"}
                />
              </div>
            </div>
          )}
        </div>

        <NewCampaignModal
          newCampaignModal={newCampaignModal}
          setNewCampaignModal={setNewCampaignModal}
          title={"Create New Campaign"}
        />
        <Modal
          open={shareCampaign}
          footer={false}
          width={558}
          height={469}
          closable={false}
          centered
        >
          <ShareCampaign
            shareCampaign={shareCampaign}
            setShareCampaign={setShareCampaign}
            campaignId={shareCampaignId}
          />
        </Modal>
        <Modal
          open={duplicateCampaign}
          footer={false}
          // className="share-campaign-model"
          width={558}
          height={260}
          closable={false}
          centered
        >
          <DuplicateCampaign
            campaignName={campaignName}
            duplicateEntireCampaign={duplicateCampaign}
            campaignId={shareCampaignId}
            setDuplicateEntireCampaign={setDuplicateCampaign}
          />
        </Modal>
        <Modal
          open={editCampaign}
          footer={false}
          className="share-campaign-model"
          width={558}
          closable={false}
          centered
        >
          <EditCampaign
            editCampaign={editCampaign}
            campaign={editCampaignEntire}
            setEditCampaign={setEditCampaign}
          />
        </Modal>

        <DeleteCamapign
          setDeleteCampaignModal={setDeleteCampaignModal}
          deleteCampaignModal={deleteCampaignModal}
          deleteCampaignId={deleteCampaignId}
          selectedCampaignPage={true}
        />

        {isLoading && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        )}
      </div>
    </>
  );
};

export default MyCampaignsPage;
